import { forumSelect } from '../forumTypeUtils';
import { afRoutes } from './afRoutes'
import { eaRoutes } from './eaRoutes'
import { lwRoutes } from './lwRoutes'

export const forumSpecificRoutes = forumSelect({
  AlignmentForum: afRoutes,
  EAForum: eaRoutes,
  LessWrong: lwRoutes,
  default: () => {},
})
